import { render, staticRenderFns } from "./myProjects.vue?vue&type=template&id=4484db7e&scoped=true&"
import script from "./myProjects.vue?vue&type=script&lang=js&"
export * from "./myProjects.vue?vue&type=script&lang=js&"
import style0 from "./myProjects.vue?vue&type=style&index=0&id=4484db7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484db7e",
  null
  
)

export default component.exports